/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgLiability32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <g stroke='currentColor' strokeMiterlimit={5} strokeWidth={1.5}>
        <path d='M23.5 24.5s1.065.473 3.292 1.377l-2.267-5.826 5.635-2.483-5.635-2.482 2.267-5.826-5.702 2.316-2.43-5.758-2.43 5.758-5.702-2.316 1.983 6.063M17.262 17.581l1.469-4.56M19.332 18.9l2.367-2.484' />
        <path
          strokeLinecap='square'
          d='M-8 27.5v-3.456c0-.98.428-1.911 1.171-2.549l2.329-1.998v0A4.997 4.997 0 01.497 14.5h6.592c.884 0 1.713.431 2.22 1.155L12 19.497l6.744 1.725A3 3 0 0121 24.128v3.329L-8 27.5z'
        />
        <path d='M16.5 23h3.926M2.5 15l1.083 4.5M-5 19.5h17' />
        <path
          fill='#fff'
          strokeLinejoin='round'
          d='M-3.195 29.957a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM12.305 29.957a2.5 2.5 0 100-5 2.5 2.5 0 000 5z'
        />
        <path d='M.5 31h31' />
      </g>
      <defs>
        <clipPath id='liability-32_svg__clip0'>
          <path fill='#fff' d='M0 0h32v32H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgLiability32;
